import { http } from "./client";

/** The four size presets a widget can take. The grid maps each to a column span. */
export type WidgetSize = "small" | "medium" | "large" | "full";

export const WIDGET_SIZES: WidgetSize[] = ["small", "medium", "large", "full"];

export const WIDGET_SIZE_LABELS: Record<WidgetSize, string> = {
  small: "Small",
  medium: "Medium",
  large: "Large",
  full: "Full width",
};

export type WidgetUnavailableReason = "" | "module_disabled" | "no_permission";

export interface DashboardWidgetMeta {
  id: string;
  category: string;
  name: string;
  description: string;
  sizes: WidgetSize[];
  default_size: WidgetSize;
  /** Whether the signed-in user can see this widget's data right now. */
  available: boolean;
  unavailable_reason?: WidgetUnavailableReason;
}

export interface DashboardCategory {
  key: string;
  label: string;
}

/** One widget's place in the layout. Position is the logical order; the grid
 * derives rows and column spans from order + size for each screen width. */
export interface DashboardLayoutItem {
  widget_id: string;
  visible: boolean;
  size: WidgetSize;
  order: number;
}

export interface DashboardLayoutView {
  categories: DashboardCategory[];
  widgets: DashboardWidgetMeta[];
  /** null: the company never customized - the original dashboard shows. */
  layout: { version: number; items: DashboardLayoutItem[]; updated_at: string } | null;
  default_items: DashboardLayoutItem[];
  customized: boolean;
  can_customize: boolean;
}

export const dashboardLayoutApi = {
  get: () => http.get<DashboardLayoutView>("/dashboard/layout"),
  /** `version` is the version the editor loaded (0 when nothing was saved);
   * a stale one is rejected with 409 so two admins never silently overwrite
   * each other. */
  save: (version: number, items: DashboardLayoutItem[]) => http.put<DashboardLayoutView>("/dashboard/layout", { version, items }),
  reset: () => http.delete<DashboardLayoutView>("/dashboard/layout"),
};
